/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const merchPages = {
    ArtistMerchPage: () => import('@/merch/ArtistMerchPage'),
    MerchDetailPage: () => import('@/merch/MerchDetailPage'),
    MerchShopPage: () => import('@/merch/MerchShopPage'),
}
